import React, { Component } from 'react';

// REDUX
import { connect } from 'react-redux';
import * as actions from 'actions';
import { BrowserRouter as Router, withRouter, Link,  } from 'react-router-dom';

// Custom components
import CompanyInterfaceForm, { ComponentWrapper, FormWrapper, TopContainer, LinkWrapper, FormColumnWrapper, FormRowWrapper  } from 'containers/CompanyContainer/CompanyInterfaceForm';
import FormImageInput from 'containers/CompanyContainer/Forms/Components/FormImageInput';
import FormTextField from 'containers/CompanyContainer/Forms/Components/FormTextField';
import FormTextArea from 'containers/CompanyContainer/Forms/Components/FormTextArea';
import FormSelectField from 'containers/CompanyContainer/Forms/Components/FormSelectField';
import FormCheckboxField from 'containers/CompanyContainer/Forms/Components/FormCheckboxField';
import FormSectionTitle from 'containers/CompanyContainer/Forms/Components/FormSectionTitle';
import CompanyPageButton from 'containers/CompanyContainer/CompanyPageButton';
import CompanyBreadcrumbs from 'components/Assests/CompanyBreadcrumbs';

// Constants
import { constants } from 'constants/index';

class EmployeeSetupForm extends CompanyInterfaceForm {

    state = {
        profilePhotoURL: null,
        firstName: '',
        lastName: '',
        email: '',
        phone: '1',
        isAccountAdmin:false,
        isStaffAdmin: false,
        isProvider: false,
        biography: '',
        expertise: '',
        designation: '',
        certifications: [],
        licenseNumber: '',
        providerLiabilityPolicyHolder: '',
        providerLiabilityPolicyNumber: '',
        isTaxExempt: false,
        taxNumber: null,
        coverPhotoURL: null,
        formValidationErrors: {},
        isLoading: false
    }

    componentDidMount(){
        const { state } = this;
        const { employee } = this.props;
        const itemValues = {};
        let formattedEmployeeData = {}
        const employeeDataIsValid = employeeItem => Object.keys(employeeItem || {}).length > 0;
        if(employeeDataIsValid(employee)){
            const formatEmployeeData = employee => ({
                ...employee,
                firstName: employee.name.first,
                lastName: employee.name.last,
                isAccountAdmin: employee.roles ? employee.roles.accountAdmin : false,
                isStaffAdmin: employee.roles ? employee.roles.staffAdmin : false,
                isProvider: employee.roles ? employee.roles.provider : false
            });

            const setItemValues = valueKey => itemValues[valueKey] = formattedEmployeeData[valueKey] || null;

            formattedEmployeeData = formatEmployeeData(employee);
            Object.keys(state).forEach(setItemValues)
            this.setState(itemValues);
        };

        this.hydrateStateWithLocalStorage();

        window.addEventListener(
            "beforeunload",
            this.saveStateToLocalStorage.bind(this)
        );
    };

    setFieldsetDefaultValues = (name) => {
        return name === 'certifications'
            ? [{
                title: '',
                suffix: '',
                provinces: constants &&
                    constants.option &&
                    constants.option.provinces &&
                    constants.option.provinces[0] &&
                    constants.option.provinces[0].value
            }]
            : [{}]
    };

    handleTextChange = (event) => {
        const { name, value } = event.target;
        const isPhone = type => type === 'phone';
        const isValidPhone = phoneString => phoneString.length <= 11;

        if(isPhone(name)){
            // Remove all special characters from the masking
            let normalizedInput = ('' + value).replace(/\D/g, '');
            // Check that the input is at max 11 characters long, which is the expected length with the area and the country code
            isValidPhone(normalizedInput) && this.setState({ [name] : normalizedInput});
        } else {
            this.setState({ [name] : value});
        }
    }

    getTopContainerActions = () => {
        return (
            <React.Fragment>
                <CompanyPageButton
                    test-label="saveButton"
                    type={'dark'}
                    size={'small'}
                    children={'Save'}
                />
            </React.Fragment>
        )
    }

    checkValidation = ({event, type, parent, index}) => {
        const { name, value } = event.target;
        const errorMessage = this.validateInput({
            type,
            value: event.target.value
        });
        let formValidationErrors = {...this.state.formValidationErrors};

        if(parent){
            formValidationErrors[parent][index][name] = errorMessage;

        } else {
            formValidationErrors[name] = errorMessage;
        }
        this.setState({formValidationErrors})
    }

    getFormFields = () => {
        const {
            isProvider
        } = this.state;
        return(
            <React.Fragment>
                <FormRowWrapper>
                    <FormColumnWrapper>
                        {this.getPersonalFields()}
                        {isProvider && this.getProviderInformationFields()}
                    </FormColumnWrapper>
                    <FormColumnWrapper>
                        {this.getPermissionFields()}
                        {isProvider && this.getProviderLegalFields()}
                        {isProvider && this.getProviderProfessionalFields()}
                        {isProvider && this.getCoverPhotoField({subTitle: "Upload an image that represents this providers expertise."})}
                    </FormColumnWrapper>
                </FormRowWrapper>
            </React.Fragment>
        )
    }

    formatEmployeeDataForDB = (event) => {
        event && event.preventDefault();
        const {
            isAccountAdmin,
            isStaffAdmin,
            isProvider
        }  = this.state;
        const { employee } = this.props;
        let formattedProviderData = this.formatProviderDataForDB();
        const additionalProviderData = {
            _id: employee ? employee.uid : null,
            uid: employee ? employee.uid : null,
            roles: {
                accountAdmin: isAccountAdmin ? isAccountAdmin : false,
                staffAdmin: isStaffAdmin ? isStaffAdmin : false ,
                provider: isProvider ? isProvider : false
            },
        }
        window.removeEventListener(
            "beforeunload",
            this.saveStateToLocalStorage.bind(this)
        );
        this.setState({ isLoading: true });
        formattedProviderData = { ...formattedProviderData, ...additionalProviderData };
        employee
            ? this.updateInfo(formattedProviderData)
            : this.saveInfo(formattedProviderData);
        // TODO VALIDATION
    }



    saveInfo = (formattedProviderData) => {
        console.log('saving item', formattedProviderData);
        let itemType = this.getItemType(formattedProviderData);
        this.props.addCompanyItem({
            companyId: this.props.userData.providerCompany,
            itemData: formattedProviderData,
            itemType
        })
        .then( success => {
            success
                ? this.props.history.push('/company/dashboard')
                : this.setState({ isLoading: false });
        });
    };

    updateInfo = (formattedProviderData) => {
        console.log('updating item');
        let itemType = this.getItemType(formattedProviderData);
        const roleChanges = this.getPermissionRolesChanges(formattedProviderData.roles)
        this.props.updateCompanyItem({
            companyId: this.props.userData.providerCompany,
            itemData: formattedProviderData,
            itemType,
            roleChanges
        })
        .then( success => {
            success
                ? this.props.history.push('/company/dashboard')
                : console.log('reset');
        });
    }


    render () {
        const {
            getTopContainerActions,
            getFormFields,
            formatEmployeeDataForDB,
            getLoader
        } = this;
        const companyRoles = this.props.userData && this.props.userData.roles;
        // console.log('employeeEditor-state', this.state)
        // console.log('employeeEditor-props', this.props)
        let loader = getLoader();
        return (
            <ComponentWrapper>
                { this.props.match && this.props.match.url &&
                    <CompanyBreadcrumbs
                        employeeId={this.props.employee && this.props.employee.uid}
                        location={this.props.match.url}
                        path={this.props.match.path}
                        companyRoles = {companyRoles}
                    />
                }
                {loader}
                <FormWrapper onSubmit={formatEmployeeDataForDB}>
                    <TopContainer>
                        {getTopContainerActions()}
                    </TopContainer>
                    {getFormFields()}
                </FormWrapper>
            </ComponentWrapper>
        )
    }
}

const mapStateToProps = ({auth, company, router, client}) => ({
    employee: company.selectedStaff,
    userData: client.clientData,
    formSubmissionSuccessful: company.formSubmissionSuccessful,
    authData: auth.authData,
    location: router.location,
});

export default withRouter(connect(mapStateToProps,actions)(EmployeeSetupForm));


// WEBPACK FOOTER //
// ./src/js/containers/CompanyContainer/EmployeeSetupForm.jsx